<template>
  <div id="modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 class="modal-title">{{config.title}}</h3>
        </div>
        <div class="modal-body">
          <div v-if="!Array.isArray(message)" v-html="message" />
          <p v-else v-for="(ctt, index) in message" :key="index" v-html="ctt" />
        </div>
        <div class="modal-footer" v-if="config.question">
          <button type="button" @click="yes()" class="btn btn-primary">
            <i class="fa fa-check"></i> {{config.labelYes}}
          </button>
          <button type="button" @click="no()" class="btn btn-default" data-dismiss="modal">
            <i class="fa fa-times"></i> {{config.labelNo}}
          </button>
        </div>
        <div class="modal-footer" v-if="!config.question">
          <button type="button" @click="close()" class="btn btn-default" data-dismiss="modal">{{config.labelOk}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  data () {
    return {
      message: 'mensagem',
      config: { 
        title: 'titulo'
       }
    }
  },
  methods: {
    confirm (message, config = {}) {
      this.message = message
      this.config = config
      this.config.title = config.title ? config.title : 'Alerta'
      this.config.labelYes = config.labelYes ? config.labelYes : 'Sim'
      this.config.labelNo = config.labelNo ? config.labelNo : 'Não'
      this.config.labelOk = config.labelOk ? config.labelOk : 'OK'
      this.config.question = !!config.question

      window.jQuery('#modal').modal('show')
    },
    yes () {
      window.jQuery('#modal').modal('hide')
      if (this.config.yes) {
        this.config.yes()
      }
    },
    no () {
      if (this.config.no) {
        this.config.no()
      }
    },
    close () {
      if (this.config.close) {
        this.config.close()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Modal.vue